import './InfoField.scss'
import { useEffect, useState } from "react";
import { format_time, formatDate, formatTime } from "../../../../Util/format_date";
import { translateWord } from "../../../../Util/util";

export default function InfoField({
    popUpType,
    channel,
    btn_show_info,
    epg,
    active_channel
}) {

    const [infoEpg, setInfoEpg] = useState({})

    useEffect(() => {
        if (epg) {
            try {
                let obj
                let objInfo = JSON.parse(epg.info)
                let objIcon = JSON.parse(epg.icon)
                obj = { ...objInfo[0], ...objIcon[0] }
                setInfoEpg({ ...obj })
            } catch (e) {

            }
        }
    }, [epg])
    return (
        epg ?
            <div className="info_field_live_player">
                <div className="main_info_field">
                    {popUpType === 'program_guide' ?
                        <div className="image_epg_now" style={{ backgroundImage: `url(${epg.src ? epg.src : infoEpg.src})` }}></div>
                        : null}
                    <div className="left_infoField">
                        <div className="live_info">
                            <div className="img_live_info">
                                {console.log(active_channel)}
                                <img src={active_channel ? active_channel.image : channel.image} alt="" />
                            </div>

                            <div className="name_live_info">
                                <span style={{ fontSize: epg && epg.name.length > 15 ? '1.8rem' : null }}>{active_channel ? active_channel.name : channel.name}</span>
                            </div>
                        </div>
                        <div className="recipe_live">
                            <span>{epg ? epg.title : null}</span>
                        </div>
                        <div className="progress_info_live">
                            <div className="progress_bar_info_live" style={epg ?
                                {
                                    width: `${(
                                        (new Date().getTime() / 1000 - epg.start_ut) / (epg.stop_ut - epg.start_ut) * 100) > 100
                                        ? 100 : ((new Date().getTime() / 1000 - epg.start_ut) / (epg.stop_ut - epg.start_ut) * 100) < 0
                                            ? 0 : (new Date().getTime() / 1000 - epg.start_ut) / (epg.stop_ut - epg.start_ut) * 100}%`
                                }
                                : null}></div>
                        </div>
                        <div className="duration_info_live">
                            <h3 className="now_streaming">{epg ? `${formatDate(new Date(epg.start_ut * 1000), 'HH:mm')} - ${formatDate(new Date(epg.stop_ut * 1000), 'HH:mm')}` : null}</h3>
                            <span className='time_info_live'>{epg ? format_time((epg.stop_ut) - (epg.start_ut)) : null}</span>
                        </div>
                    </div>
                    <div className="right_info_field">
                        <div className="description_info_live">
                            <div className="top_description_info_live">
                                {/* <div className="date_desc_field">{epg ? formatDate(new Date(epg.date), 'yyyy') : null}</div> */}
                                {
                                    infoEpg.genre && infoEpg.genre.length ?
                                        <div className="genre_desc_field">
                                            {epg.genre.map((e, i) => epg.genre.length === i + 1 ? e.name + '' : e.name + ',')}
                                        </div>
                                        : null
                                }
                                <div className="pg_desc_field">
                                    <span>{epg && epg.pg && epg.pg != 0 ? '+' + epg.pg : translateWord('All')}</span>
                                </div>
                            </div>
                            <p className="desc_info_live">{epg.desc && epg.desc.length > 300 ? epg.desc.slice(0, 300) + '...' : epg.desc} </p>
                        </div>
                        {
                            popUpType === 'program_guide' ? null :
                                <div className="btn_close_info_live" onClick={btn_show_info}>
                                    <span>{translateWord('Close')}</span>
                                </div>
                        }

                    </div>
                </div>
            </div>
            : null
    )

}